import { Component } from '@angular/core';
import { Input } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnAuthorizedComponent {
  @Input() sidenav: any;
}

